import { PageId } from 'constants/pages'

export const enum PageIdWoofzK9Drsl {
  DOG_AGE_K9_DRSL = PageId.DOG_AGE_K9_DRSL,
  DOG_SEX_K9_DRSL = PageId.DOG_SEX_K9_DRSL,
  DOG_BREED_K9_DRSL = PageId.DOG_BREED_K9_DRSL,
  DOG_BREED_ID_K9_DRSL = PageId.DOG_BREED_ID_K9_DRSL,
  URGE_K9_DRSL = PageId.URGE_K9_DRSL,
  CHALLENGES_K9_DRSL = PageId.CHALLENGES_K9_DRSL,
  URGE_1_K9_DRSL = PageId.URGE_1_K9_DRSL,
  LEASH_PULLING_K9_DRSL = PageId.LEASH_PULLING_K9_DRSL,
  URGE_LEASH_K9_DRSL = PageId.URGE_LEASH_K9_DRSL,
  DURING_WALK_K9_DRSL = PageId.DURING_WALK_K9_DRSL,
  URGE_NOT_ALONE_K9_DRSL = PageId.URGE_NOT_ALONE_K9_DRSL,
  AGRESSIVE_BEHAVIOR_K9_DRSL = PageId.AGRESSIVE_BEHAVIOR_K9_DRSL,
  TRIGGERS_K9_DRSL = PageId.TRIGGERS_K9_DRSL,
  URGE_2_K9_DRSL = PageId.URGE_2_K9_DRSL,
  BEHAVIOR_ISSUES_K9_DRSL = PageId.BEHAVIOR_ISSUES_K9_DRSL,
  DOG_ACT_K9_DRSL = PageId.DOG_ACT_K9_DRSL,
  DOG_OFF_AT_HOME_K9_DRSL = PageId.DOG_OFF_AT_HOME_K9_DRSL,
  REWARDS_K9_DRSL = PageId.REWARDS_K9_DRSL,
  IGNORE_COMMANDS_K9_DRSL = PageId.IGNORE_COMMANDS_K9_DRSL,
  COMMANDS_61_K9_DRSL = PageId.COMMANDS_61_K9_DRSL,
  COMMANDS_62_K9_DRSL = PageId.COMMANDS_62_K9_DRSL,
  COMMANDS_63_K9_DRSL = PageId.COMMANDS_63_K9_DRSL,
  URGE_3_K9_DRSL = PageId.URGE_3_K9_DRSL,
  PREPARE_SCREEN_K9_DRSL = PageId.PREPARE_SCREEN_K9_DRSL,
  DOG_PROFILE_K9_DRSL = PageId.DOG_PROFILE_K9_DRSL,
  URGE_REVIEWED_K9_DRSL = PageId.URGE_REVIEWED_K9_DRSL,
  PREPARE_FLOW_K9_DRSL = PageId.PREPARE_FLOW_K9_DRSL,
  EMAIL_K9_DRSL = PageId.EMAIL_K9_DRSL,
  NEWSLETTER_URGE_K9_DRSL = PageId.NEWSLETTER_URGE_K9_DRSL,
  WELCOME_TO_WOOFZ_K9_DRSL = PageId.WELCOME_TO_WOOFZ_K9_DRSL,
  SUBSCRIPTIONS_K9_DRSL = PageId.SUBSCRIPTIONS_K9_DRSL,
  CHAT_UPSELL_K9_DRSL = PageId.CHAT_UPSELL_K9_DRSL,
  UPSELL_K9_DRSL = PageId.UPSELL_K9_DRSL,
  UPSELL_FEEDING_GUIDE_K9_DRSL = PageId.UPSELL_FEEDING_GUIDE_K9_DRSL,
  UPSELL_EMOTIONAL_SUPPORT_K9_DRSL = PageId.UPSELL_EMOTIONAL_SUPPORT_K9_DRSL,
  DOWNLOAD_K9_DRSL = PageId.DOWNLOAD_K9_DRSL,
  ACCOUNT_K9_DRSL = PageId.ACCOUNT_K9_DRSL,
}
